import { EMPTY_LIST } from '../../../constants/common'
import { DOC_FLOW_UPLOADING_ENTITY } from '../../../constants/entity'
import { DocFlowMappingType } from '../DocFlow.constants'

export const DOC_FLOW_UPLOADING_TABLE_FILTER_STATE_URL = `/idwell-api/api/v3/table/filter-states/${DOC_FLOW_UPLOADING_ENTITY.plural}/all/`

export const DOC_FLOW_UPLOADING_TABLE_CONFIG_URL = `/idwell-api/api/v3/table/tables/${DOC_FLOW_UPLOADING_ENTITY.plural}/`

export const DOC_FLOW_UPLOADING_TABLE_ACTIONS_COLUMN_WIDTH = 96

export const DOC_FLOW_UPLOADING_EMPTY_REQUEST_PARAMS = {
  filters: {},
  ordering: EMPTY_LIST,
}

export const DOC_FLOW_UPLOADING_DEFAULT_TYPE = DocFlowMappingType.Splitting
